import React from "react";
import Form from "./Form";

function Contact() {
  return (
    <div
      className="w-full flex flex-col justify-center mt-40"
      id="5"
    >
      <div className="text-4xl font-bold text-center text-yellow-500">Contact Me</div>
      <Form />
    </div>
  );
}

export default Contact;
